import axios from "axios"
import type { CheapFlight, FlightContinent, MCFlight, RTWFlight, Level1Data, Level1DestinationInfo, FlightsTableResponse } from '../Types'

const {VITE_EXPRESS_API, VITE_EXPRESS_API_IE} = import.meta.env

const getApiBase = () =>
    window.siteVar?.referer === 'IE' ? VITE_EXPRESS_API_IE : VITE_EXPRESS_API

// Generic helper for all stopover API calls
const fetchFromApi = async (path: string) => {
    try {
        const url = `${getApiBase()}${path}?formatted=yes`
        const res = await axios.get(url)

        if (res && res.data) {
            const data = res.data
            return data ?? []
        } else if (!res || (res && !res.data)) {
            return []
        }

    } catch (e) {
        return []
    }
}

export const getStaffPhotos = async (nameList: string[]) => {
    try {
        const url = `${getApiBase()}/flights/stopovers/staffphotos?formatted=yes`
        const res = await axios.post(url, {nameList})

        if (res && res.data) {
            const data = res.data
            return data ?? []
        } else if (!res || (res && !res.data)) {
            return []
        }

    } catch (e) {
        return []
    }
}


// Specific endpoints
export const getStopovers = (keyword: string) => 
    fetchFromApi(`/flights/stopovers/tours/${keyword}`)

export const getHotels = () =>
    fetchFromApi(`/flights/stopovers/hotels`)

export const getLocalTours = () =>
    fetchFromApi(`/flights/stopovers/localtours`)

export const getTopTips = () =>
    fetchFromApi(`/flights/stopovers/toptips`)

const CHEAPEST_DESTINATIONS = ['New York', 'Dubai', 'Vancouver', 'Bangkok', 'Sydney', 'Perth', 'Cape Town', 'Auckland']

export const getCheapestFlights = async (): Promise<CheapFlight[]> => {
    const referer = window.siteVar?.referer ?? 'UK'
    try {
        const res = await axios.post(`${getApiBase()}/flights/get-cheapest`, { keys: CHEAPEST_DESTINATIONS, referer })
        return res?.data ?? []
    } catch {
        return []
    }
}

export const getCheapestAllFlights = async (): Promise<FlightContinent[]> => {
    const referer = window.siteVar?.referer ?? 'UK'
    try {
        const res = await axios.post(`${getApiBase()}/flights/get-cheapest-all`, { referer })
        return res?.data?.flights ?? []
    } catch {
        return []
    }
}

export const getFlightsByContinent = async (continent: string): Promise<Level1Data> => {
    const referer = window.siteVar?.referer ?? 'UK'
    try {
        const res = await axios.post(`${getApiBase()}/flights/get-cheapest-all`, { referer, continent })
        return { flights: res?.data?.flights ?? [], destination: res?.data?.destination ?? null }
    } catch {
        return { flights: [], destination: null }
    }
}

export const getFlightByKey = async (key: string, mapsKey?: string): Promise<{ flights: any[]; destination: Level1DestinationInfo | null }> => {
    try {
        const res = await axios.post(`${getApiBase()}/flights/get-by-key`, { key, maps_key: mapsKey })
        return { flights: res?.data?.flights ?? [], destination: res?.data?.destination ?? null }
    } catch {
        return { flights: [], destination: null }
    }
}

export const getFlightsTable = async (destination: string): Promise<FlightsTableResponse> => {
    const referer = window.siteVar?.referer ?? 'UK'
    try {
        const res = await axios.post(`${getApiBase()}/flights/get-flights-table`, { destination, referer })
        return { flightsArray: res?.data?.flightsArray ?? [], phoneNumbers: res?.data?.phoneNumbers ?? [] }
    } catch {
        return { flightsArray: [], phoneNumbers: [] }
    }
}

export const getMultiCentreFlights = async (): Promise<MCFlight[]> => {
    const referer = window.siteVar?.referer ?? 'UK'
    try {
        const res = await axios.get(`${getApiBase()}/flights/multi-centre/${referer}`)
        return res?.data ?? []
    } catch {
        return []
    }
}

export const getRTWFlights = async (): Promise<RTWFlight[]> => {
    const referer = window.siteVar?.referer ?? 'UK'
    try {
        const res = await axios.get(`${getApiBase()}/flights/rtw/${referer}`)
        return res?.data ?? []
    } catch {
        return []
    }
}